import { motion } from 'framer-motion'
import Link from 'next/link'
import React from 'react'
import styled, { css } from 'styled-components'
import { Anchor } from 'lib/Link'
import { textSize, textWeight } from 'lib/Text'
import { useUiContext } from 'modules/UiContext'

type Variant = 'small' | 'big'

export const itemVariants = {
  menuOpen: {
    opacity: 1
  },
  menuClosed: {
    opacity: 0
  }
}

const AnchorLink = styled(Anchor)<{ variant: Variant; as?: string }>`
  ${textWeight('semi')}
  ${(props) => props.variant === 'big' && textSize('l')}
  ${(props) => props.variant === 'small' && textSize('ps')}
  color: white;
  padding: 0 var(--item-padding);
  display: inline-block;
  border-bottom: none;

  &:hover {
    color: white;
    border-bottom: none;
  }

  ${(props) =>
    props.as === 'button' &&
    css`
      appearance: none;
      background: none;
      border: none;
      cursor: pointer;
    `}
`

const Item = styled(motion.div)`
  margin-bottom: var(--item-padding);

  &:last-child {
    margin-bottom: 0;
  }
`

interface Base {
  title: string
  variant?: Variant
  onClick?: () => void
}

interface LinkProps extends Base {
  href: string
  as?: string
  type: 'anchor'
}

interface ButtonProps extends Base {
  type: 'button'
}

type Props = LinkProps | ButtonProps

export const NavMenuItem = (props: Props) => {
  const { title, variant = 'big', type, onClick = () => {} } = props
  const { setMenuOpen } = useUiContext()

  return (
    <Item variants={itemVariants} onClick={() => setMenuOpen(false)}>
      {type === 'anchor' && (
        <Link href={props.href} as={props.as} passHref prefetch={false}>
          <AnchorLink onClick={onClick} variant={variant}>
            {title}
          </AnchorLink>
        </Link>
      )}

      {type === 'button' && (
        <AnchorLink as="button" variant={variant} onClick={onClick}>
          {title}
        </AnchorLink>
      )}
    </Item>
  )
}
